import { type } from 'arktype';

/** Contrato de `userNiche`: interés declarado de una persona por un nicho (documento 02a, §5.4). */
export const userNicheResponseSchema = type({
	id: 'string.uuid',
	nicheId: 'string.uuid',
	userId: 'string.uuid',
	// Cuánto le interesa ese nicho; por defecto 1.0 en la base de datos.
	weight: 'number',
}).onUndeclaredKey('delete');

export type UserNicheResponse = typeof userNicheResponseSchema.infer;

const userNicheItemSchema = type({
	nicheId: 'string.uuid',
	weight: 'number',
}).onUndeclaredKey('delete');

/**
 * `PUT /me/niches` (§6.3 del documento 02a, endpoint ausente que hace falta): declara de
 * una vez la lista completa de intereses de la sesión. Es PUT, no PATCH: reemplaza la
 * lista entera, no la parchea elemento a elemento.
 */
export const putUserNichesSchema = userNicheItemSchema.array();

export type PutUserNiches = typeof putUserNichesSchema.infer;
